export default __webpack_public_path__ + "static/media/world-tour.d462b0d9.jpg";